// sentry
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

Sentry.init({
    release: EnvVars.app.sentryRelease,
    environment: EnvVars.app.environment || "production",
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN || "",
    integrations: [
        new Integrations.Vue({attachProps: true, logErrors: true}), 
    ],
    ignoreErrors: [
        "This browser does not support audio output selection",
        "Request failed with status code 590"
    ],
    normalizeDepth: 5,
    beforeSend(event, hint) {
        while (JSON.stringify(event).length > 100000 && event.breadcrumbs.length > 1) {
            event.breadcrumbs.shift();
        }
        return event;
    },
});

Sentry.setUser({ id: window.user_id, username: window.user_name });
Sentry.setTag("windowToken", sessionStorage.windowToken);
Sentry.setTag("pageToken", EnvVars.session.pageToken);
